import angular from 'angular';
import './service';
import './style.scss';

angular.module('TALENYA-FE').controller('bulkClaimPopupCtrl', function (
    $uibModalInstance,
    BulkClaimService,
    data,
    onSubmit,
) {
    const self = this;

    const { candidates, recruiterId } = data;

    self.counters = BulkClaimService.getCounters({ candidates, recruiterId });
    self.candidates = candidates;
    self.isDataSaving = false;
    self.ok = async function () {
        self.isDataSaving = true;
        await onSubmit(self.counters.aboutToClaim);
        $uibModalInstance.close('Ok');
    };

    self.cancel = function () {
        $uibModalInstance.dismiss('Cancel');
    };
});
